// export const INITIAL_CREDIT = 5000;
// export const INITIAL_CREDIT = 1000;
export const TOKENS_PER_CREDIT = 100; // adjust to match your model
export const MIN_TRANSCRIBE_CREDIT = 50;
export const CREDITS_PER_IMAGE = 10;
export const MIN_GENERATE_CREDIT = 50;
export const GUEST_CREDIT = 500;
// 🧮 Define your pricing model
export const INITIAL_CREDIT = 1000;
export const REFERRAL_BONUS = 500;
export const MIN_CREDITS = 10;
export const MAX_DURATION_VERCEL = 60;

// export const TOPUP_OPTIONS = [
//   { credits: 5000, price: 5 },
//   { credits: 10000, price: 10 },
//   { credits: 15000, price: 15, tag: 'Popular' },
//   { credits: 25000, price: 25 },
//   { credits: 40000, price: 40 },
//   { credits: 60000, price: 60, tag: 'Best Value' },
//   { credits: 100000, price: 99 }
// ];

export const TOPUP_OPTIONS = [
  { credits: 4500, price: 5 },       // 900 credits/$
  { credits: 9500, price: 10 },      // 950 credits/$
  { credits: 15000, price: 15, tag: 'Popular' }, // 1000 credits/$
  { credits: 27000, price: 25 },     // 1080 credits/$
  { credits: 45000, price: 40 },     // 1125 credits/$
  { credits: 70000, price: 60, tag: 'Best Value' }, // 1167 credits/$
  { credits: 120000, price: 99 }     // ~1212 credits/$
];

export function GET_CREDIT_DETAILS_FROM_AMOUNT(amount: number): {
  credits: number;
  pricePerCredit: string;
  savingsPercent: string;
} {
  const base = TOPUP_OPTIONS[0];
  const basePricePerCredit = base.price / base.credits;

  // Check for exact match in predefined top-up options
  const matched = TOPUP_OPTIONS.find((option) => option.price === amount);
  let credits: number;
  let effectiveRate: number;

  if (matched) {
    credits = matched.credits;
    effectiveRate = matched.price / matched.credits;
  } else {
    // Use best rate for custom amount
    const bestRate = TOPUP_OPTIONS[TOPUP_OPTIONS.length - 1];
    const creditPerDollar = bestRate.credits / bestRate.price;
    credits = Math.round(amount * creditPerDollar);
    effectiveRate = amount / credits;
  }

  const savings = 1 - effectiveRate / basePricePerCredit;
  const roundedSavings = Math.round(savings * 100);

  return {
    credits,
    pricePerCredit: `$${effectiveRate.toFixed(4)} / credit`,
    savingsPercent: `${roundedSavings}%`,
  };
}

export function CALCULATE_CREDITS_USED(prompt: string, response: string): number {
  const promptTokens = prompt.split(/\s+/).length;
  const responseTokens = response.split(/\s+/).length;
  const totalTokens = promptTokens + responseTokens;
  return Math.ceil(totalTokens / 10); // 1 credit per 10 tokens
}
// input: 25157
// output: 26283
// credits: -433
// OpenAI	GPT-4o
// gpt-4o
// 128K/16K	$2.5	$10	$0.3257	$32.57
// OpenAI	GPT-4.1
// gpt-4.1
// 1M/32K	$2	$8	$0.2606	$26.06
// OpenAI	GPT-4.1 mini
// gpt-4.1-mini
// 1M/32K	$0.4	$1.6	$0.0521	$5.21
// OpenAI	GPT-4.1 nano
// gpt-4.1-nano
// 1M/32K	$0.1	$0.4	$0.0130	$1.30
// OpenAI	GPT-4.5
// gpt-4.5-preview
// 128K/16K	$75	$150	$5.8292	$582.92
// OpenAI	GPT-4o mini
// gpt-4o-mini
// 128K/16K	$0.15	$0.6	$0.0195	$1.95
// OpenAI	GPT-4o Mini Audio (Text)
// gpt-4o-mini-audio-preview
// 128K	$0.15	$0.6	$0.0195	$1.95
// OpenAI	GPT-4o Mini Realtime (Text)
// gpt-4o-mini-realtime-preview
// 128K	$0.6	$2.4	$0.0782	$7.82
// OpenAI	o4-mini
// o4-mini
// 200K/100K	$1.1	$4.4	$0.1433	$14.33
// OpenAI	o3
// o3
// 200K/100K	$10	$40	$1.3029	$130.29
// OpenAI	o3-mini
// o3-mini
// 200K/100K	$1.1	$4.4	$0.1433	$14.33
// OpenAI	o1
// o1
// 200K/100K	$15	$60	$1.9543	$195.43
// OpenAI	o1-mini
// o1-mini
// 128K/65K	$1.1	$4.4	$0.1433	$14.33

// Google	Gemini 2.5 Flash
// gemini-2.5-flash
// 1M	$0.15	$0.6	$0.0195	$1.95
// Google	Gemini 2.5 Pro
// gemini-2.5-pro-preview-03-25
// 200K	$1.25	$10	$0.2943	$29.43
// Google	Gemini 2.5 Pro
// gemini-2.5-pro-preview-03-25
// 1M	$2.5	$15	$0.4571	$45.71
// Google	Gemini 2.0 Flash
// gemini-2.0-flash
// 1M	$0.1	$0.4	$0.0130	$1.30
// Google	Gemini 2.0 Flash-Lite
// gemini-2.0-flash-lite
// 1M	$0.075	$0.3	$0.0098	$0.98

// free = 0 $ = 100 Credit
// Pro = 8 $ = 1 000 Credit
// Pro = 13 $ = 2 000 Credit
// Pro = 17 $ = 3 000 Credit
// Pro = 25 $ = 5 000 Credit
// Pro = 38 $ = 10 000 Credit
// Pro = 99 $ = 30 000 Credit

export const PLANS = [
  {
    name: "Free",
    slug: "free",
    quota: 2,
    projects: 1,
    price: {
      amount: 0,
      priceIds: {
        test: "price_test_free",
        production: "price_prod_free",
      },
    },
  },

  {
    name: "Starter",
    slug: "starter",
    quota: 50,
    projects: 3,
    price: {
      amount: 17,
      priceIds: {
        test: "price_1QXdSCL69NseQykDQYLQQB9K",
        production: "price_1Q2gFnL69NseQykD4djDGlue",
      },
    },
  },
  {
    name: "Pro",
    slug: "pro",
    quota: 150,
    projects: 7,
    price: {
      amount: 29,
      priceIds: {
        test: "price_1QXdSoL69NseQykDHo3ft8cJ",
        production: "price_1Q2gG8L69NseQykDHRsDf2qD",
      },
    },
  },
  {
    name: "Agency",
    slug: "agency",
    quota: 450,
    projects: 20,
    price: {
      amount: 49,
      priceIds: {
        test: "price_1QXdV6L69NseQykDbSptyY5x",
        production: "price_1Q2gI3L69NseQykDUIsKjwJE",
      },
    },
  },
  {
    name: "Business",
    slug: "business",
    quota: 1000,
    projects: 50,
    price: {
      amount: 99,
      priceIds: {
        test: "price_1QXdVnL69NseQykDEXMpBWAN",
        production: "price_1Q2gIRL69NseQykDEVJNrNKT",
      },
    },
  },
  {
    name: "Enterprise",
    slug: "enterprise",
    quota: 5000,
    projects: 100,
    price: {
      amount: "Custom",
      priceIds: {
        test: "price_test_enterprise",
        production: "price_prod_enterprise",
      },
    },
  },
];
export const PRICINGPLANS = [
  {
    plan: "Free",
    tagline: "For freelancers and small projects.",
    quota: PLANS.find((p) => p.slug === "free")?.quota,
    price: {
      amount: 0,
      priceIds: {
        test: "",
        production: "",
      },
    },
    features: [
      {
        text: "AI-powered website creation",
        footnote: "Create websites using AI and existing templates.",
      },
      {
        text: "Basic CMS capabilities",
        footnote: "Edit content with limited customization.",
      },
      {
        text: "GitHub integration",
        footnote: "Single-user access to GitHub repositories.",
      },
      {
        text: "Basic analytics and SEO tools",
        footnote: "Fundamental metrics for SEO and analytics.",
      },
      {
        text: "Export pure HTML, CSS, JS code",
        footnote: "Designed for small projects.",
      },
      {
        text: "Community-based support",
        negative: true,
        footnote: "Support provided via community forums.",
      },
    ],
  },
  {
    plan: "Starter",
    tagline: "For freelancers and small projects.",
    quota: PLANS.find((p) => p.slug === "starter")?.quota,

    features: [
      {
        text: "AI-powered website creation",
        footnote: "Create websites using AI and existing templates.",
        negative: true,
      },
      {
        text: "Basic CMS capabilities",
        footnote: "Edit content with limited customization.",
        negative: true,
      },
      {
        text: "GitHub integration",
        footnote: "Single-user access to GitHub repositories.",
        negative: true,
      },
      {
        text: "Basic analytics and SEO tools",
        footnote: "Fundamental metrics for SEO and analytics.",
        negative: true,
      },
      {
        text: "Export pure HTML, CSS, JS code",
        footnote: "Designed for small projects.",
        negative: true,
      },
      {
        text: "Community-based support",
        negative: true,
        footnote: "Support provided via community forums.",
      },
    ],
  },
  {
    plan: "Pro",
    tagline: "For small teams and professionals.",
    quota: PLANS.find((p) => p.slug === "pro")?.quota,
    price: PLANS.find((p) => p.slug === "pro")?.price.priceIds.production,
    features: [
      {
        text: "Advanced CMS capabilities",
        footnote: "Multi-user access with additional storage.",
        negative: true,
      },
      {
        text: "Advanced GitHub integration",
        footnote: "Support for team-based workflows.",
      },
      {
        text: "Enhanced analytics and SEO tools",
        footnote: "Additional metrics for deeper analysis.",
        negative: true,
      },
      {
        text: "Advanced AI-powered website creation",
        footnote: "More sophisticated AI tools.",
        negative: true,
      },
      {
        text: "Moderate storage/bandwidth",
        footnote: "Suitable for small teams.",
        negative: true,
      },
      {
        text: "Email and chat support",
        footnote: "Direct support from customer service.",
        negative: true,
      },
    ],
  },
  {
    plan: "Agency",
    tagline: "For small agencies or larger teams.",
    quota: PLANS.find((p) => p.slug === "agency")?.quota,
    price: PLANS.find((p) => p.slug === "agency")?.price.priceIds.production,
    features: [
      {
        text: "Full CMS capabilities",
        footnote: "Advanced user roles and permissions.",
        negative: false,
      },
      {
        text: "Advanced GitHub integration",
        footnote: "Multiple repositories and team collaboration.",
        negative: false,
      },
      {
        text: "Advanced AI-powered website creation",
        footnote: "Extensive AI features for design.",
        negative: false,
      },
      {
        text: "Full e-commerce capabilities",
        footnote: "Comprehensive e-commerce tools.",
        negative: false,
      },
      {
        text: "Enhanced security features",
        footnote: "Multi-factor authentication and audit logs.",
        negative: false,
      },
      {
        text: "Priority support",
        footnote: "Faster response times and dedicated support.",
        negative: false,
      },
    ],
  },

  {
    plan: "Entreprise",
    tagline: "For large organizations with specialized needs.",
    quota: PLANS.find((p) => p.slug === "entreprise")?.quota,
    price: "Contact us",
    features: [
      {
        text: "Customizable user roles and permissions",
        footnote: "Fully configurable user access.",
        negative: false,
      },
      {
        text: "White-labeling options",
        footnote: "Branding with your company's identity.",
        negative: false,
      },
      {
        text: "Integration with enterprise tools",
        footnote: "CI/CD platforms and marketing automation.",
        negative: false,
      },
      {
        text: "Premium security features",
        footnote: "Advanced encryption and compliance support.",
        negative: false,
      },
      {
        text: "Dedicated account manager",
        footnote: "Personalized assistance for your account.",
        negative: false,
      },
      {
        text: "Unlimited storage/bandwidth",
        footnote: "Designed for large-scale use.",
        negative: false,
      },
    ],
  },
];
